module.exports = __webpack_public_path__ + "img/sulv_3.78f71a5f.jpg";